export default {
  whoWeAre: "Wer wir sind",
  whoWeAreDescription: "Eine führende pharmazeutische Plattform mit über 40 Jahren API-Exzellenz, globalen Partnerschaften in fortgeschrittenen Zwischenprodukten und CRDMO-Expertise in Spezialformulierungen und Antibiotika.",
  globalImpactExcellence: "Globale Wirkung & Exzellenz",
  globalImpactDescription: "Vertraut von Partnern weltweit für die Bereitstellung bedeutsamer Innovationen durch Wissenschaft.",
  whatWeOffer: "Was wir anbieten",
  whatWeOfferDescription: "Umfassende pharmazeutische Lösungen, gestützt auf jahrzehntelange Expertise und globale Reichweite, die Innovation vom Labor zum Leben in verschiedenen therapeutischen Bereichen liefern.",
  regulatoryApprovals: "Regulatorische Zulassungen",
  regulatoryApprovalsDescription: "Refex Life Sciences betreibt ein weltweites Netzwerk von hochmodernen Produktionsstätten, die nahtlos in die Gruppe integriert sind. Diese Einrichtungen entsprechen den höchsten internationalen Qualitätsstandards mit Akkreditierungen von:",
  regulatoryApproval1: "US FDA",
  regulatoryApproval2: "EU GMP",
  regulatoryApproval3: "EDQM",
  regulatoryApproval4: "Health Canada",
  regulatoryApproval5: "ANVISA",
  regulatoryApproval6: "PMDA",
  regulatoryApproval7: "WHO-GMP",
  noOfferingsAvailable: "Keine Angebote verfügbar. Bitte fügen Sie einige im Admin-Panel hinzu.",
};

